'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchPostalCodeFormat = exports.matchEmailFormat = exports.matchTelFormat = exports.removeSpace = exports.isNull = void 0;
// 空白チェック
function isNull(val) {
    return this.removeSpace(val) == '';
}
exports.isNull = isNull;
// 空白文字の削除
function removeSpace(val) {
    return val ? val.replace(/\s+/g, '') : '';
}
exports.removeSpace = removeSpace;
// 電話番号のフォーマットチェック
function matchTelFormat(val) {
    return val.match(/[0-9]{2,4}[\-]{0,1}[0-9]{2,4}[\-]{0,1}[0-9]{2,4}/);
}
exports.matchTelFormat = matchTelFormat;
// メールのフォーマットチェック
function matchEmailFormat(val) {
    return val.match(/^[0-9a-zA-Z]+[0-9a-zA-Z\-\+_\.]+@[0-9a-zA-Z\-\+_\.]+\.[0-9a-zA-Z\-\+_\.]+$/g);
}
exports.matchEmailFormat = matchEmailFormat;
// 郵便番号のフォーマットチェック
function matchPostalCodeFormat(val) {
    return val.match(/^[0-9]{3}-?[0-9]{4}$/);
}
exports.matchPostalCodeFormat = matchPostalCodeFormat;
